import { Controller } from "@hotwired/stimulus"

// Undo the builder default action item types for this company and phase
// (Phelipe 2026-10-15) — Settings → Action Items, ConsLog admins only. The
// undo changes the whole types list, so the page reloads and the toast is
// carried over in sessionStorage.
const FLASH_KEY = "action_item_defaults_flash"

export default class extends Controller {
  static targets = ["modal", "confirmBtn"]
  static values = { url: String }

  connect() {
    this._showPendingFlash()
  }

  open() {
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async confirm() {
    const btn = this.confirmBtnTarget
    if (btn.disabled) return
    btn.disabled = true
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const resp = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Accept": "application/json", "X-CSRF-Token": token },
        credentials: "same-origin"
      })
      const data = await resp.json().catch(() => ({}))
      if (!resp.ok) throw new Error(data.error || "Couldn't undo.")
      try { sessionStorage.setItem(FLASH_KEY, JSON.stringify({ message: data.message, type: "notice" })) } catch (_) { /* toast is optional */ }
      window.location.reload()
    } catch (err) {
      btn.disabled = false
      this._showToast(err.message, "alert")
    }
  }

  _showPendingFlash() {
    let raw = null
    try {
      raw = sessionStorage.getItem(FLASH_KEY)
      sessionStorage.removeItem(FLASH_KEY)
    } catch (_) { return }
    if (!raw) return
    try {
      const { message, type } = JSON.parse(raw)
      this._showToast(message, type)
    } catch (_) { /* ignore */ }
  }

  _showToast(message, type = "notice") {
    const el = document.createElement("div")
    el.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    el.textContent = message
    document.body.prepend(el)
  }
}
